import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { WorkingHoursPayload } from '../models/working-hours.paylod.model';
import { Observable } from 'rxjs';
import { DefaultDataWrapper } from '../../../shared/models/default-data-wrapper.model';
import { GetWorkingHours } from '../models/get-working-hours.model';

@Injectable({ providedIn: 'root' })
export class WorkingHoursApiService {
  private http = inject(HttpClient);

  getWorkingHours(userId: Array<number>) {
    return this.http.post<DefaultDataWrapper<Array<GetWorkingHours>>>('/corporate-client/driver/show/working-hours', {
      user_id: Number(userId)
    });
  }

  saveWorkingHours(payload: WorkingHoursPayload): Observable<any> {
    return this.http.patch<any>('/corporate-client/driver/edit/working-hours', payload);
  }
}
